// @todo Clean this mess up.
import $ from "jquery";
Drupal.behaviors.copyToClipboad = {
  attach: function(context) {
    const copy = $('.copy-link', context);
    copy.click(function(event) {
      console.log("hello");
    });
  }
};
/*     const copy = $('.copy-link', context); */
    /* console.log("hello") */

    /*   var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove(); */
      /* e.preventDefault(); */
